import { IDatalayerKey, IDatalayerMapInstance, IDatalayerViewerFactory, isString, LayerTypeId, NumericValuesViewer, PrescriptionType } from "../../omnia"

export class PrescriptionPlanViewer extends NumericValuesViewer {

    public static createFactory(): IDatalayerViewerFactory {

        return {
            typeId: LayerTypeId.PrescriptionPlan,
            name: "Prescription plan",
            createViewer: layer => new PrescriptionPlanViewer(layer, { colorProvider: createColorProvider(layer) })
        }

    }

    // constructor(layer: IDatalayerMapInstance<IDatalayerZoneMapInstance>) {
    //     super(layer)
    // }

    public refresh() {

        const plan = getPlanInfo(this._layer)

        if (plan) {
            this._units = plan.UnitName
        }

        super.refresh()

    }

    public getValueFillColor(value: number, alpha: number = 1) {
        const color = super.getValueFillColor(value, alpha)
        return color || [255, 255, 255, 0.5]
    }

    getKey(): IDatalayerKey {

        const key = super.getKey()

        const plan = getPlanInfo(this._layer)

        if (plan) {

            return {
                ...key,
                id: `preplan-${plan.Guid}`,
                name: plan.PlanName,
                fixed: true
            }

        }

        return key

    }

    protected setupMinMaxZoneValues() {

        super.setupMinMaxZoneValues()

        const plan = getPlanInfo(this._layer)
        if (!plan) return

        const { MinRate, MaxRate } = plan

        this._minZoneValue = MinRate || 0
        this._maxZoneValue = MaxRate || 0

    }


}


interface PlanInfo {
    Guid: string
    Type: PrescriptionType
    PlanName: string
    UnitName: string
    MinRate: number
    MaxRate: number
}

function getPlanInfo(layer: IDatalayerMapInstance): PlanInfo {

    if (layer.typeId === LayerTypeId.PrescriptionPlan) {

        const info = layer.datalayer.LayerData

        if (isPlanInfo(layer.datalayer.LayerData)) {
            return info
        }

    }

}

function isPlanInfo(a: any): a is PlanInfo {
    return ((typeof (a) === "object") && isString(a["PlanName"]))
}

function createColorProvider(layer: IDatalayerMapInstance) {

    const plan = getPlanInfo(layer)

    if (plan) {

        const type = omnia.prescriptionTypes.find(t => t.type === plan.Type)

        if (type) {
            return new omnia.color.NumericRangeColorProvider(type.style.gradient, false)
        }


    }

}
